export function SegmentedControl({ options, value, onChange, className = '' }) {
  return (
    <div className={`flex rounded-lg border border-border bg-surface p-1 ${className}`} role="tablist">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={`flex-1 min-h-[2.5rem] rounded-md px-1.5 py-1.5 text-xs font-medium leading-tight transition-colors sm:min-h-touch sm:px-2 sm:py-2 sm:text-sm ${
            value === opt.value ? 'bg-card text-primary shadow-sm' : 'text-muted hover:text-text'
          }`}
        >
          <span className="label-wrap block text-center">{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
